(function () {
  'use strict';

  if (window.__kalmeFavicon) return;
  window.__kalmeFavicon = true;

  if (document.documentElement.classList.contains('shopify-design-mode')) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SIZE = 64;
  var FPS = 8;
  var FRAME_MS = 1000 / FPS;
  var link = document.getElementById('kalme-favicon');
  if (!link) {
    link = document.createElement('link');
    link.id = 'kalme-favicon';
    link.rel = 'icon';
    document.head.appendChild(link);
  }

  var canvas = document.createElement('canvas');
  canvas.width = SIZE;
  canvas.height = SIZE;
  var ctx = canvas.getContext('2d');
  if (!ctx) return;

  var last = 0;
  var start = 0;
  var running = false;

  function roundRect(x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
  }

  function petal(cx, cy, rx, ry, rot) {
    ctx.save();
    ctx.translate(cx, cy);
    ctx.rotate(rot);
    ctx.beginPath();
    ctx.ellipse(0, 0, rx, ry, 0, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();
  }

  function blade(x, y, lean, h) {
    ctx.beginPath();
    ctx.moveTo(x, y);
    ctx.quadraticCurveTo(x + lean * 0.35, y - h * 0.55, x + lean, y - h);
    ctx.stroke();
  }

  function draw(t) {
    var s = SIZE / 32;
    ctx.clearRect(0, 0, SIZE, SIZE);
    ctx.save();
    ctx.scale(s, s);

    roundRect(0, 0, 32, 32, 7);
    ctx.fillStyle = '#f3eee6';
    ctx.fill();
    ctx.clip();

    ctx.beginPath();
    ctx.ellipse(16, 26.2, 11, 3.6, 0, 0, Math.PI * 2);
    ctx.fillStyle = '#e4d8c4';
    ctx.fill();

    ctx.strokeStyle = '#8fa38a';
    ctx.lineWidth = 1.25;
    ctx.lineCap = 'round';
    var wind = Math.sin(t * 1.5);
    blade(8.5, 25.2, -2.2 + wind * 0.7, 8.6);
    blade(11.2, 25.6, -1.6 + wind * 0.55, 8.2);
    blade(21.2, 25.6, 1.8 + wind * 0.55, 8);
    blade(24.2, 25.2, 2.4 + wind * 0.7, 8.4);

    var sway = Math.sin(t * 1.2) * 0.07;
    ctx.save();
    ctx.translate(16, 22.6);
    ctx.rotate(sway);

    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(0, -8.4);
    ctx.strokeStyle = '#6d8468';
    ctx.lineWidth = 1.3;
    ctx.stroke();

    ctx.fillStyle = '#fffdf9';
    petal(0, -13.2, 2.05, 3.7, 0);
    petal(0, -6.2, 2.05, 3.7, 0);
    petal(-3.5, -9.7, 3.7, 2.05, 0);
    petal(3.5, -9.7, 3.7, 2.05, 0);
    petal(-2.5, -12.3, 2.1, 3.3, -0.7);
    petal(2.5, -12.3, 2.1, 3.3, 0.7);
    petal(-2.5, -7.1, 2.1, 3.3, 0.7);
    petal(2.5, -7.1, 2.1, 3.3, -0.7);

    ctx.beginPath();
    ctx.arc(0, -9.7, 2.55, 0, Math.PI * 2);
    ctx.fillStyle = '#e6b84a';
    ctx.fill();
    ctx.beginPath();
    ctx.arc(0.55, -10.25, 0.7, 0, Math.PI * 2);
    ctx.fillStyle = '#f3d27a';
    ctx.fill();
    ctx.restore();

    var flap = 0.38 + 0.62 * (0.5 + 0.5 * Math.sin(t * 11));
    var hx = 24.85 + Math.sin(t * 1.7) * 0.7;
    var hy = 8.15 + Math.cos(t * 2.1) * 0.55;
    ctx.save();
    ctx.translate(hx, hy);
    ctx.rotate(Math.sin(t * 1.6) * 0.18);

    ctx.fillStyle = '#e8b4a2';
    ctx.save();
    ctx.scale(-flap, 1);
    ctx.beginPath();
    ctx.ellipse(2.1, -1.7, 3.3, 2.15, -0.48, 0, Math.PI * 2);
    ctx.fill();
    ctx.beginPath();
    ctx.ellipse(1.7, 1.05, 2.5, 1.7, -0.32, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();

    ctx.save();
    ctx.scale(flap, 1);
    ctx.beginPath();
    ctx.ellipse(2.1, -0.85, 3.3, 2.15, 0.38, 0, Math.PI * 2);
    ctx.fill();
    ctx.beginPath();
    ctx.ellipse(1.6, 1.45, 2.5, 1.7, 0.28, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();

    ctx.beginPath();
    ctx.ellipse(0, 0, 0.7, 2.05, 0, 0, Math.PI * 2);
    ctx.fillStyle = '#c48a72';
    ctx.fill();

    ctx.strokeStyle = '#5c6b58';
    ctx.lineWidth = 0.7;
    ctx.beginPath();
    ctx.moveTo(-0.35, -2);
    ctx.quadraticCurveTo(-1.1, -3.1, -1.85, -3.4);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(0.35, -2);
    ctx.quadraticCurveTo(1.1, -3.1, 1.85, -3.4);
    ctx.stroke();
    ctx.restore();

    ctx.restore();
  }

  function setIcon() {
    var href = canvas.toDataURL('image/png');
    var next = link.cloneNode(false);
    next.id = 'kalme-favicon';
    next.rel = 'icon';
    next.type = 'image/png';
    next.href = href;
    if (link.parentNode) {
      link.parentNode.replaceChild(next, link);
      link = next;
    } else {
      link.href = href;
    }
  }

  function tick(now) {
    if (!running) return;
    if (!start) start = now;
    if (now - last >= FRAME_MS) {
      last = now;
      draw((now - start) / 1000);
      setIcon();
    }
    requestAnimationFrame(tick);
  }

  function play() {
    if (running || document.hidden) return;
    running = true;
    last = 0;
    requestAnimationFrame(tick);
  }

  function pause() {
    running = false;
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) pause();
    else play();
  });

  play();
})();
